import {
  Box,
  Card,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React from "react";
import CustomIcon from "../../../../common/CustomIcon/CustomIcon";
import { isFeatureAvailable } from "../../../../utils/Utility";
import { useAppSelector } from "../../../../store/hooks";
import { RootState } from "../../../../store/store";
import { t } from "i18next";

interface ICheckboxList {
  label: string;
  featureCode: string;
}
interface PolicyChangeCardProps {
  title: string;
  lobCode: string;
  checkboxList: ICheckboxList[];
  selectedPolicyChange: string;
  setSelectedPolicyChange: (policy: string) => void;
}
const PolicyChangeCard: React.FC<PolicyChangeCardProps> = ({
  title,
  lobCode,
  checkboxList,
  selectedPolicyChange,
  setSelectedPolicyChange,
}) => {
  const { features } = useAppSelector((state: RootState) => state.features);

  const getIcon = (linecode: string) => {
    switch (linecode) {
      case "PA":
        return <CustomIcon iconName="Car" />;
      case "HO":
        return <CustomIcon iconName="Home" />;
      case "PU":
        return <CustomIcon iconName="Umbrella" />;
      case "BOP":
        return <CustomIcon iconName="Business" />;
      case "FO":
        return <CustomIcon iconName="Farm" />; // Using Farm icon for Farm Owners
    }
  };

  return (
    <Card
      sx={{
        display: "flex",
        alignItems: "start",
        justifyContent: "flex-start",
        padding: "1rem",
        gap: "1rem",
      }}
    >
      {getIcon(lobCode)}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Typography variant="h6" alignSelf="flex-start">
          {t(title)}
        </Typography>
        <RadioGroup
          name={lobCode}
          value={selectedPolicyChange}
          onChange={(e) => setSelectedPolicyChange(e.target.value)}
          sx={{ alignSelf: "flex-start" }}
        >
          {checkboxList.map((checkbox, index) => (
            <FormControlLabel
              sx={{ alignSelf: "flex-start" }}
              key={index}
              control={
                <Radio
                  value={checkbox.label}
                  disabled={
                    !isFeatureAvailable({
                          featureCodes: [checkbox?.featureCode],
                          features,
                        })
                  }
                />
              }
              label={t(checkbox.label)}
            />
          ))}
        </RadioGroup>
      </Box>
    </Card>
  );
};

export default PolicyChangeCard;
